function calculateWaterRates() {
  let tier1Units = 5;
  let tier2Units = 8;

  const rates = {
    water: {
      service: {
        "m-.75": [34.06, 44.53, 48.10, 51.95],
        "m-1": [50.38, 70.58, 76.23, 82.33],
        "m-1.5": [91.17, 135.70, 146.56, 158.29],
        "m-2": [140.13, 213.85, 230.96, 249.44],
        "m-3": [295.16, 461.32, 498.23, 538.09],
        "m-4": [523.62, 826.02, 892.10, 963.47],
      },
      usage: {
        tier: [
          [5.96, 5.56, 6.01, 6.5],
          [11.09, 11.52, 12.45, 13.45],
          [15.63, 18.26, 19.73, 21.31],
        ],
        nonTier: [9.45, 9.79, 10.58, 11.43],
      },
    },
    wastewater: {
      sf: {
        service: [29.3, 12.82, 14.74, 16.95],
      },
      mf: {
        service: [34.51, 34.18, 39.31, 45.21],
      },
      com: {
        service: [34.51, 51.27, 58.97, 67.81],
      },
    },
  };

  let totalsWater = [0, 0, 0, 0];
  let totalsWastewater = [0, 0, 0, 0];
  let totalDifference = [0, 0, 0, 0];
  const customerTypes = ["sf", "mf", "com"];

  const section = document.querySelector("section.water_rate_calculator");
  if (!section) return;

  const customerType =
    section.querySelector("select#customer_type")?.value || "sf";
  let meterSize = section.querySelector("select#meter_size")?.value || "m-.75";
  const waterService =
    section.querySelector("select#water_service")?.value === "yes";
  const wastewaterService =
    section.querySelector("select#wastewater_service")?.value === "yes";
  let units = parseInt(
    section.querySelector("input#units")?.value || "0",
    10
  );
  const householdSize = parseInt(
    section.querySelector("input#household_size")?.value || "4",
    10
  );
  const lotSize = parseInt(
    section.querySelector("input#lot_size")?.value || "10000",
    10
  );

  if (customerType === "sf" && householdSize) {
    tier1Units = Math.round((householdSize * 47 * 30) / 1000);
  }

  if (customerType === "sf" && lotSize) {
    const tier2UnitsMultiplier = lotSize > 14510 ? 4353 : lotSize * 0.3;
    tier2Units = Math.round(
      (tier2UnitsMultiplier * 0.12 * 0.8 * 0.623 * 30) / 1000
    );
  }

  customerTypes.forEach((type) => {
    if (type === customerType) {
      section.classList.add(type);
    } else {
      section.classList.remove(type);
    }
  });

  if (waterService) {
    section.classList.add("water-service");
  } else {
    section.classList.remove("water-service");
  }

  if (wastewaterService) {
    section.classList.add("wastewater-service");
  } else {
    section.classList.remove("wastewater-service");
  }

  if (isNaN(units)) {
    units = 0;
  }

  if (typeof rates.water.service[meterSize] === "undefined") {
    meterSize = "m-.75";
  }

  const estimatedWaterUsage = Math.round(units / 2);

  const estimatedWaterUsageInput = section.querySelector(
    "input#estimated_water_usage"
  );

  if (estimatedWaterUsageInput) {
    estimatedWaterUsageInput.value = estimatedWaterUsage;
  }

  const table = section.querySelector("table.rates");
  if (!table) return;

  const waterBaseRow = table.querySelector("tr#water-base");
  if (waterBaseRow) {
    const cells = waterBaseRow.querySelectorAll("td:not(:first-child)");
    cells.forEach((cell, i) => {
      totalsWater[i] += rates.water.service[meterSize][i];
      cell.textContent = rates.water.service[meterSize][i].toFixed(2);
    });
  }

  const tierUnitsCurr = [
    estimatedWaterUsage > 5 ? 5 : estimatedWaterUsage,
    estimatedWaterUsage - 5 > 0
      ? estimatedWaterUsage - 5 > 8
        ? 8
        : estimatedWaterUsage - 5
      : 0,
    estimatedWaterUsage - 13 < 0 ? 0 : estimatedWaterUsage - 13,
  ];

  const tier1UnitsBreak = tier1Units + 1;
  const tier2UnitsBreak = tier2Units + tier1UnitsBreak;
  const tiers2total = tier1Units + tier2Units;

  const tierUnitsNew = [
    estimatedWaterUsage > tier1UnitsBreak ? tier1Units : estimatedWaterUsage,
    estimatedWaterUsage > tier1UnitsBreak
      ? estimatedWaterUsage > tier2UnitsBreak
        ? tier2Units
        : estimatedWaterUsage - tier1Units
      : 0,
    estimatedWaterUsage > tiers2total ? estimatedWaterUsage - tiers2total : 0,
  ];

  if (customerType === "sf") {
    const tierRows = table.querySelectorAll("tr.tier");
    tierRows.forEach((tr, t) => {
      const cells = tr.querySelectorAll("td:not(:first-child)");
      cells.forEach((td, i) => {
        const tierUnits = i === 0 ? tierUnitsCurr : tierUnitsNew;
        let subtotal =
          customerType === "sf"
            ? rates.water.usage.tier[t][i] * tierUnits[t]
            : rates.water.usage.nonTier[i] * tierUnits[t];
        totalsWater[i] += subtotal;
        if (subtotal > 0) {
          td.textContent = subtotal.toFixed(2);
          td.classList.remove("zero");
        } else {
          td.textContent = "";
          td.classList.add("zero");
        }
      });
    });
  } else {
    const waterUsageRow = table.querySelector("tr#water-usage");
    if (waterUsageRow) {
      const cells = waterUsageRow.querySelectorAll("td:not(:first-child)");
      cells.forEach((cell, i) => {
        let subtotal = rates.water.usage.nonTier[i] * estimatedWaterUsage;
        totalsWater[i] += subtotal;
        if (subtotal > 0) {
          cell.textContent = subtotal.toFixed(2);
          cell.classList.remove("zero");
        } else {
          cell.textContent = "";
          cell.classList.add("zero");
        }
      });
    }
  }

  if (wastewaterService) {
    const wastewaterServiceChargeRow = table.querySelector(
      "tr#wastewater-service-charge"
    );
    if (wastewaterServiceChargeRow) {
      const cells = wastewaterServiceChargeRow.querySelectorAll(
        "td:not(:first-child)"
      );
      cells.forEach((cell, i) => {
        let subtotal = rates.wastewater[customerType].service[i];
        if (i > 0) {
          subtotal *= householdSize;
        }
        if (customerType === "com" && i === 0) {
          subtotal *= householdSize;
        }
        totalsWastewater[i] += subtotal;
        if (subtotal > 0) {
          cell.textContent = subtotal.toFixed(2);
          cell.classList.remove("zero");
        } else {
          cell.textContent = "";
          cell.classList.add("zero");
        }
      });
    }
  }

  const waterTotalRow = table.querySelector("tr#water-total");
  if (waterTotalRow) {
    const cells = waterTotalRow.querySelectorAll("td:not(:first-child)");
    cells.forEach((cell, i) => {
      cell.textContent = totalsWater[i].toFixed(2);
    });
  }

  const wastewaterTotalRow = table.querySelector("tr#wastewater-total");
  if (wastewaterTotalRow) {
    const cells = wastewaterTotalRow.querySelectorAll("td:not(:first-child)");
    cells.forEach((cell, i) => {
      cell.textContent = totalsWastewater[i].toFixed(2);
    });
  }

  const totalRow = table.querySelector("tr#total");
  if (totalRow) {
    const cells = totalRow.querySelectorAll("td:not(:first-child)");
    cells.forEach((cell, i) => {
      const total = totalsWater[i] + totalsWastewater[i];
      cell.textContent = total.toFixed(2);

      if (i > 0) {
        totalDifference[i] =
          total - (totalsWater[i - 1] + totalsWastewater[i - 1]);
      }
    });
  }

  const totalDifferenceRow = table.querySelector("tr#total-difference");
  if (totalDifferenceRow) {
    const cells = totalDifferenceRow.querySelectorAll("td:not(:first-child)");
    cells.forEach((cell, i) => {
      if (i > 0) {
        if (totalDifference[i] > 0) {
          cell.textContent = totalDifference[i].toFixed(2);
          cell.classList.remove("zero");
        } else {
          cell.textContent = "";
          cell.classList.add("zero");
        }
      } else {
        cell.textContent = "";
        cell.classList.add("zero");
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector("section.water_rate_calculator");
  if (!section) return;

  const inputs = section.querySelectorAll("input");
  inputs.forEach((input) => {
    input.addEventListener("keyup", calculateWaterRates);
    input.addEventListener("change", calculateWaterRates);
  });

  const selects = section.querySelectorAll("select");
  selects.forEach((select) => {
    select.addEventListener("change", calculateWaterRates);
  });

  calculateWaterRates();
});
